import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { QuestionnaireShareConfirmationDialogComponent } from './questionnaire-share-confirmation-dialog/questionnaire-share-confirmation-dialog.component';
import { QuestionnaireConfirmationData } from './models/questionnaire-confirmation-data.model';
import { QuestionnaireShareDialogComponent } from '@features/questionnaire-renderer/questionnaire-share-dialog/questionnaire-share-dialog.component';
import { QuestionnaireShareData } from '@features/questionnaire-renderer/models/questionnaire-selection-data.model';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireDialogService {
  private readonly dialog = inject(MatDialog);
  private _currentStep = 1;
  stepCount = 2;

  /**
   * get current step
   */
  get currentStep(): number {
    return this._currentStep;
  }

  /**
   * increase current step by 1
   */
  increaseCurrentStep(): void {
    this._currentStep++;
  }

  /**
   * resets current to 1
   */
  resetCurrentStep(): void {
    this._currentStep = 1;
  }

  openShareDialog(
    data: QuestionnaireShareData,
  ): MatDialogRef<QuestionnaireShareDialogComponent> {
    return this.dialog.open<
      QuestionnaireShareDialogComponent,
      QuestionnaireShareData
    >(QuestionnaireShareDialogComponent, {
      width: '700px',
      disableClose: true,
      data,
      panelClass: 'full-width',
    });
  }

  openShareConfirmationDialog(
    data: QuestionnaireConfirmationData,
  ): MatDialogRef<QuestionnaireShareConfirmationDialogComponent> {
    return this.dialog.open(QuestionnaireShareConfirmationDialogComponent, {
      width: '700px',
      disableClose: true,
      data,
    });
  }
}
